<template>
  <div class="full-height">
    <div
      :class="{
        simpleButtons: rowButtons,
        crudButtons: !rowButtons,
        cleanLayout: cleanLayout,
      }"
      class="row container q-px-sm"
    >
      <div class="fit">
        <q-card class="q-px-sm card-crud">
          <q-card-section class="q-py-sm card-title">
            <div class="crud-title">
              <translate>SEARCH_RESULT</translate>
            </div>
          </q-card-section>
          <q-card-section class="tw-flex tw-justify-end">
            <q-btn
              flat
              icon="mdi-bell-ring"
              class="tw-text-white tw-bg-secondary tw-flex tw-items-center"
              @click="sendCampaign"
              :disable="!selectedCampaign"
            >
              <span class="tw-ml-2">
                <translate>SEND_CAMPAIGN</translate>
              </span>
            </q-btn>
          </q-card-section>
          <q-card-section class="q-pb-lg card-table">
            <jt-data-table
              v-if="nmInterface && !slots.table"
              ref="jtDataTable"
              class="table-crud"
              :forms="forms"
              :buttons="datatable.buttons"
              :buttons-filter="filterButtons"
              :fields="datatable.columns"
              :extra-params="extraParam"
              :default-http-options="defaultHttpOptions"
              :nm-interface="nmInterface"
              singleselect
              :row-buttons="rowButtons"
              :selection-force="selectionForce"
              :column-edit="columnEdit"
              :row-set="rowSet"
              :bottom-edit="bottomEdit"
              :multiselect="multiselect"
              :noneselect="noneselect"
              @selection="selection"
              @action-button="actionButton"
              @show-message="showMessage"
              @click-row="
                (row) => {
                  $emit('click-row', row);
                }
              "
            >
              <template #header="{}">
                <span />
              </template>
              <template #body="{ props }">
                <q-tr class="text-left colapse-area">
                  <q-td auto-width>
                    <q-checkbox
                      :value="props.row.id === selectedCampaign"
                      @input="handleSelection(props.row)"
                    ></q-checkbox>
                  </q-td>
                  <q-td
                    v-for="col in props.cols"
                    :key="col.name"
                    :props="props"
                    style="colapse-area"
                  >
                    <strong>{{ col.label }}:</strong>
                    {{ col.value }}
                  </q-td>
                  <q-td auto-width>
                    <q-btn
                      flat
                      icon="mdi-arrow-collapse-vertical"
                      class="tw-text-warmGray-600"
                      @click="openCloseTable(props.row.id)"
                      :disable="
                        zendeskSendCampaingsArray(
                          props.row.zendeskSendCampaings
                        ).length == 0
                      "
                    />
                  </q-td>
                </q-tr>
                <q-tr class="table-header" v-if="expandedRows[props.row.id]">
                  <q-td colspan="100%">
                    <div class="detail-grid">
                      <div class="detail-col">
                        {{ String($gettext("COD")).toUpperCase() }}
                      </div>
                      <div class="detail-col">
                        {{
                          String(
                            $gettext("TOTAL_COVERAGE")
                          ).toUpperCase()
                        }}
                      </div>
                    </div>
                  </q-td>
                </q-tr>
                <q-tr
                  class="text-left"
                  v-for="zendeskSendCampaing in zendeskSendCampaingsArray(
                    props.row.zendeskSendCampaings
                  )"
                  :key="zendeskSendCampaing.id"
                >
                  <q-td colspan="100%" v-if="expandedRows[props.row.id]">
                    <div class="detail-grid">
                      <div class="detail-col">
                        <span>{{
                          zendeskSendCampaing.id
                        }}</span>
                      </div>
                      <div class="detail-col">
                        <span>{{
                          zendeskSendCampaing.comprehensiveQuantity
                        }}</span>
                      </div>
                    </div>
                  </q-td>
                </q-tr>
              </template>
            </jt-data-table>
          </q-card-section>
        </q-card>
      </div>
    </div>
  </div>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtCrud, JtDataTable } from 'jtech-webcomps'

const { pageTable } = JtCrud

@Component({
  name: 'CampaignPageTable',
  mixins: [pageTable],
  components: {
    JtDataTable
  },
  props: {
    id: String,
    nmInterface: String,
    name: String,
    page: Object,
    someProp: String
  }
})
class CampaignPageTable extends Vue {
  selectedCampaign = null;
  zendeskCampaingType = null;
  expandedRows = {};

  zendeskSendCampaingsArray (string) {
    return string ? JSON.parse(string) : []
  }

  openCloseTable (rowId) {
    this.$set(this.expandedRows, rowId, !this.expandedRows[rowId])
  }

  get isDisabled () {
    return (row) => {
      const zendeskSendCampaings = this.zendeskSendCampaingsArray(
        row.zendeskSendCampaings
      )
      return zendeskSendCampaings.length === 0
    }
  }

  handleSelection (row) {
    this.zendeskCampaingType = row.zendeskCampaingType
    this.selectedCampaign = row.id
  }

  sendCampaign () {
    this.$emit(
      'action-button',
      { name: 'send-campaign' },
      {
        selectedCampaign: this.selectedCampaign,
        zendeskCampaingType: this.zendeskCampaingType
      },
      this
    )
  }
}

export default CampaignPageTable
</script>

<style lang="scss" scoped>
@import "tailwindcss/utilities";

.colapse-area {
  background-color: #5898aa;
  color: #000;
}

.table-header {
  background-color: #f1f1f1;
  margin: 30px;
}

.detail-grid {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.detail-col {
  width: 50%;
  padding: 8px;
}
</style>
